import { ICartState } from './stateInterface'
import { ISelectionRequest, IPlaceRequest, ISelection } from './interfaces'

export default {
  SELECTIONS: (state: ICartState, getters: any) => {
    /*if (getters.ISCLASSIC) {
      return state.classicPicks;
    }*/
    return state.dailyPicks;
  },
  SELECTIONS_COUNT: (state: ICartState, getters: any) => {
    /*if (getters.ISCLASSIC) {
      return state.classicPicks.length;
    }*/
    return state.dailyPicks.length;
  },
  HAS_SELECTION: (state: ICartState, getters: any) => (matchup: string, player: string) => {
    const picks = state.dailyPicks
    //const picks = getters.ISCLASSIC ? state.classicPicks : state.dailyPicks

    const has: boolean = (picks.findIndex((s: ISelection) => {
      if (!s) { return false }
      if (!s.pick) { return false }
      return s.matchupId === matchup && s.pick.player.id === player
    }) > -1)
    return has
  },
  GET_PLACE_REQUEST: (state: ICartState, getters: any) => (fee: number) => {
    const picks = state.dailyPicks
    //const picks = getters.ISCLASSIC ? state.classicPicks : state.dailyPicks

    const pickList = picks.map( (p) => {
      return { 
        matchupId: p.matchupId,
        matchupPosition: p.pick ? p.pick.matchupPosition : ''
      } as ISelectionRequest
    } )

    return {
      fee: fee,
      picks: pickList
    } as IPlaceRequest
  }
};
